import React, { useState, useEffect, useRef } from 'react';

import { ImagesApp } from '../../constants/images';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as S from './select.style';

type OptionType = {
  value: string | number;
  name: string;
};

interface SelectProps {
  value: string | number;
  onChange: (value: string | number) => void;
  data: OptionType[];
}

const Select: React.FC<SelectProps> = ({ value, onChange, data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { translate } = useI18nContext();
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (value: string | number) => {
    onChange(value);
    setIsOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <S.SelectContainer ref={containerRef}>
      <S.SelectedValueContainer onClick={toggleDropdown}>
        <S.SelectedValue>
          {data.find((item) => item.value === value)?.name || translate(['TICKET_TEMPLATE', 'SELECT_SESSION'])}
        </S.SelectedValue>
        <S.ArrowIcons>
          <img
            src={ImagesApp.svg[isOpen ? 'arrowUp' : 'arrowDown']}
            alt="seta pra cima"
          />
        </S.ArrowIcons>
      </S.SelectedValueContainer>

      {isOpen && (
        <S.Dropdown>
          {data.map((item, index) => (
            <S.Option key={`${item.value}-${index}`} onClick={() => handleOptionClick(item.value)}>
              {item.name}
            </S.Option>
          ))}
        </S.Dropdown>
      )}
    </S.SelectContainer>
  );
};

export default Select;
